import script from "./DriveInternoListaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DriveInternoListaPage.vue?vue&type=script&setup=true&lang=js"

import "./DriveInternoListaPage.vue?vue&type=style&index=0&id=61e666e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e666e2"]])

export default __exports__